<template>
  <div :class="wrapClass">
    <div :class="labelClass">
      <div
        v-if="title"
        class="row"
      >
        <div class="col-12">
          <label :class="labelTitleClass">
            {{ title }}
            <required-badge v-show="required" />
          </label>
        </div>
      </div>
      <label
        v-for="(description, index) in descriptions"
        :key="index"
        :class="labelDescriptionClass"
      >
        {{ description }}
      </label>
    </div>
    <error-message :errors="errors" />
    <div
      :class="{ 'field_with_errors': errors.length > 0 }"
    >
      <input
        ref="numericInput"
        :value="displayValue"
        type="text"
        class="form-control"
        :class="{
          'disabled': disabled,
        }"
        :placeholder="placeholder"
        @input="changeValue($event)"
        @compositionend="compositionSubmit($event)"
      />
      <input
        :value="value"
        :name="postName"
        type="hidden"
      />
    </div>
  </div>
</template>

<script>
import ErrorMessage from "./ErrorMessage.vue";
import RequiredBadge from "./RequiredBadge.vue";

export default {
  components: {
    ErrorMessage,
    RequiredBadge
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    descriptions: {
      type: Array,
      default() {
        return [];
      }
    },
    postName: {
      type: String,
      default: "survey_text"
    },
    required: {
      type: Boolean,
      default: false
    },
    labelClass: {
      type: String,
      default: "mb-3"
    },
    labelTitleClass: {
      type: String,
      default: ""
    },
    labelDescriptionClass: {
      type: String,
      default: "mt-description font-small text-dark-gray description"
    },
    errors: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    wrapClass: {
      type: String,
      default: "mb-6"
    },
    placeholder: {
      type: String,
      default: ""
    },
    maxValue: {
      type: Number,
      default: 0
    },
    defaultValue: {
      type: String,
      default: ""
    },
    formatType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      value: {
        type: String,
        default: ""
      },
      displayValue: {
        type: String,
        default: ""
      }
    };
  },
  mounted() {
    this.value = this.defaultValue;
    const displayValue = this.formatDisplayValue(this.value);

    this.displayValue = displayValue;
    this.$refs.numericInput.value = displayValue;
    this.$emit("change", this.value, this.displayValue);
  },
  methods: {
    compositionSubmit(event) {
      this.changeValueAndFormat(event.target.value);
    },
    changeValue(event) {
      if (event.inputType === "insertCompositionText") {
        return;
      }
      this.changeValueAndFormat(event.target.value);
    },
    changeValueAndFormat(nowValue) {
      const convertValue = this.convertInteger(nowValue);

      if (this.isOverMaxValue(convertValue)) {
        const displayValue = this.formatDisplayValue(this.maxValue);

        this.value = this.maxValue;
        this.displayValue = displayValue;
        this.$refs.numericInput.value = displayValue;
        this.$refs.numericInput.selectionStart = -1;
        this.$refs.numericInput.selectionEnd = -1;
        this.$emit("change", this.value, this.displayValue);
        return;
      }

      const displayValue = this.formatDisplayValue(convertValue);
      const cursorPosition = this.calculateCursorPosition(nowValue, displayValue, this.$refs.numericInput.selectionEnd);

      this.value = convertValue;
      this.displayValue = displayValue;
      this.$refs.numericInput.value = displayValue;
      this.$refs.numericInput.selectionStart = cursorPosition;
      this.$refs.numericInput.selectionEnd = cursorPosition;
      this.$emit("change", this.value, this.displayValue);
    },
    convertInteger(val) {
      const targetValue = val.replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248));

      return targetValue.replace(/\D/g, "");
    },
    isOverMaxValue(val) {
      if (this.maxValue !== 0 && val > this.maxValue) {
        return true;
      }
      return false;
    },
    formatDisplayValue(val) {
      if (this.formatType === "money") {
        return this.convertMoneyFormat(val);
      }
      return val;
    },
    convertMoneyFormat(val) {
      const convertValue = String(val).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");

      return convertValue;
    },
    calculateCursorPosition(nowValue, displayValue, selectionEnd) {
      const cursorAfterStringLength = nowValue.slice(selectionEnd).length;
      const cursorPosition = displayValue.length - cursorAfterStringLength;

      if (cursorPosition < 0) {
        return 0;
      }
      return cursorPosition;
    }
  }
};
</script>

<style scoped>
.description {
  display: block;
}
.disabled {
  background-color: inherit;
  border: none;
}
</style>
